// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.safety-container {
  padding: 20px;
}
.safety-container .emergency-section {
  margin-bottom: 20px;
  text-align: center;
}
.safety-container .emergency-section .emergency-button {
  width: 200px;
  height: 60px;
  font-size: 1.2em;
}
.safety-container ion-card {
  margin: 1rem;
  border-radius: var(--ion-border-radius);
  box-shadow: var(--ion-box-shadow);
}
.safety-container ion-card ion-card-content {
  padding: 1rem;
}
.safety-container mat-card {
  margin-bottom: 20px;
}
.safety-container .alerts-section {
  max-height: 300px;
  overflow-y: auto;
}

ion-card {
  margin: 16px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
}
ion-card ion-card-header ion-card-title ion-icon {
  margin-right: 8px;
  font-size: 1.4rem;
}

ion-item {
  --padding-start: 8px;
  --inner-padding-end: 8px;
}
ion-item ion-icon {
  font-size: 1.4rem;
}

ion-button {
  height: 48px;
  font-weight: 600;
  --box-shadow: 0 4px 8px rgba(var(--ion-color-danger-rgb), 0.2);
}

.emergency-button {
  margin: 24px 16px;
}

ion-header {
  background: transparent;
}
ion-header ion-toolbar {
  --background: transparent;
}

ion-back-button {
  --color: var(--ion-color-primary);
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/safety/safety.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,mBAAA;EACA,kBAAA;AACJ;AACI;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AACN;AAGE;EACE,YAAA;EACA,uCAAA;EACA,iCAAA;AADJ;AAGI;EACE,aAAA;AADN;AAKE;EACE,mBAAA;AAHJ;AAME;EACE,iBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,cAAA;EACA,wCAAA;AALF;AAQI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AANN;AAQM;EACE,iBAAA;EACA,iBAAA;AANR;;AAYA;EACE,oBAAA;EACA,wBAAA;AATF;AAWE;EACE,iBAAA;AATJ;;AAaA;EACE,YAAA;EACA,gBAAA;EACA,8DAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACI,uBAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;;AAcE;EACE,iCAAA;AAXJ;AACA,4mFAA4mF","sourcesContent":[".safety-container {\n  padding: 20px;\n\n  .emergency-section {\n    margin-bottom: 20px;\n    text-align: center;\n\n    .emergency-button {\n      width: 200px;\n      height: 60px;\n      font-size: 1.2em;\n    }\n  }\n\n  ion-card {\n    margin: 1rem;\n    border-radius: var(--ion-border-radius);\n    box-shadow: var(--ion-box-shadow);\n    \n    ion-card-content {\n      padding: 1rem;\n    }\n  }\n\n  mat-card {\n    margin-bottom: 20px;\n  }\n\n  .alerts-section {\n    max-height: 300px;\n    overflow-y: auto;\n  }\n}\n\nion-card {\n  margin: 16px 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n  ion-card-header {\n    ion-card-title {\n      display: flex;\n      align-items: center;\n      font-size: 1.2rem;\n      font-weight: 600;\n\n      ion-icon {\n        margin-right: 8px;\n        font-size: 1.4rem;\n      }\n    }\n  }\n}\n\nion-item {\n  --padding-start: 8px;\n  --inner-padding-end: 8px;\n\n  ion-icon {\n    font-size: 1.4rem;\n  }\n}\n\nion-button {\n  height: 48px;\n  font-weight: 600;\n  --box-shadow: 0 4px 8px rgba(var(--ion-color-danger-rgb), 0.2);\n}\n\n.emergency-button {\n  margin: 24px 16px;\n}\n\nion-header {\n    background: transparent;\n    \n    ion-toolbar {\n      --background: transparent;\n    }\n  }\n\n  ion-back-button {\n    --color: var(--ion-color-primary);\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
